export default __webpack_public_path__ + "img/9b2aec5dd5f2c081a256aa4ab44bb0df.png";